import { AllowedReducer } from '@leverege/api-redux';
import I18N from '@leverege/i18n';
import { Context } from '@leverege/plugin';
import { GlobalState } from '@leverege/ui-redux';
import { Dialogs } from '@leverege/ui-elements';
import { DataSources } from '@leverege/ui-attributes';
import RecovrReconciliation from '../../util/RecovrReconciliation';
import ReconcileJobDialog from './ReconcileJobDialog';
const {
  t,
  tIcon
} = I18N.ns('recovr.job.reconcileJob.ReconcileJobAction');
export default {
  id: 'recovr.job.reconcileLost',
  name: 'Reconcile Job',
  layout: {
    sort: 'job.reconcile'
  },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    path: 'location.jobs',
    objectType: 'parentLogUploadJob'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'parentLogUploadJob',
    objectType: 'parentLogUploadJob'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'company.locations.jobs',
    objectType: 'parentLogUploadJob'
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: ['contextMenu', 'mobileActionBar']
  }],
  appearance: props => {
    const {
      context
    } = props;
    const {
      target
    } = context;
    const count = target?.length > 1 ? target?.length : '';
    const plural = count > 1 ? 'Jobs' : 'Job';
    return {
      name: t('name', {
        count,
        plural
      }),
      icon: tIcon('icon')
    };
  },
  isPrepared: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'parentLogUploadJob');
    if (targets == null || targets.length === 0) {
      return true;
    }
    const jobId = targets[0]?.id;
    const a = AllowedReducer.get(GlobalState.get(), jobId);
    return a.reconcile != null;
  },
  prepare: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'parentLogUploadJob');
    const job = targets?.[0];
    const a = AllowedReducer.get(GlobalState.get(), job.id);
    if (a.reconcile != null) return null;
    return RecovrReconciliation.canReconcileJob({
      job
    });
  },
  handles: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'parentLogUploadJob');
    if (targets == null || targets.length === 0) {
      return false;
    }
    const jodId = targets[0]?.id;
    const a = AllowedReducer.get(GlobalState.get(), jodId);
    return a.reconcile === true;
  },
  perform: async props => {
    const {
      context
    } = props;
    const jobs = Context.getTargetsOfType(context, 'parentLogUploadJob');
    if (!jobs) {
      return;
    }
    const actions = DataSources.getActions(jobs[0]);
    Dialogs.show({
      id: 'reconcileJobs',
      component: ReconcileJobDialog,
      props: {
        jobs,
        actions
      }
    });
  }
};